export const noBackgroundColor: string = "#4ECDC4"